module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box american-credit-partner"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#ffffff",
      "color": "rgb(84, 86, 255)",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "1px solid rgb(84, 86, 255)",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        return this.window.open('https://youtu.be/JH96Q66Y4Hc', '_blank')
      }
    }
  }, [_vm._v("Watch Demo")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Team Customer Voice Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("I need to spend my time meeting customers’ expectations, not on lengthy loan applications.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("Let’s Talk")]), _vm._v(" "), _vm._m(7)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("The American "), _c('br'), _vm._v("Credit"), _c('sup', [_vm._v("®")]), _vm._v(" team")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Get the credit you deserve from a lender you can trust. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "american-credit-team-head-img",
    attrs: {
      "src": require("../assets/imgs/American_Credit_Team_Member.png"),
      "alt": "American Credit Team Member Corey Rockafeler"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#053a7a"
    }
  }, [_c('div', {
    staticClass: "container bluebg text-center"
  }, [_c('br'), _vm._v(" "), _c('h1', {
    staticClass: "display-5 text-whitee text-center font-weight-bolder"
  }, [_vm._v("One fine team, one great goal")]), _vm._v(" "), _c('div', {
    staticClass: "contexbox text-center"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "h5 font-weight-bold"
  }, [_vm._v("\n            Getting you the secured business loan you need is what we’re\n            all about.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "text-whitee"
  }, [_vm._v("\n            American Credit’s team is as diverse as the small business community it serves. We bring together a wide range of skills and personalities—all dedicated to delivering equipment loans and invoice/AR financing for your business, reflecting expertise in everything from finance, security and IT to support and customer service, our team members have one focus: You.\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container whitebg text-center"
  }, [_c('div', {
    staticClass: "contexbox text-center"
  }, [_c('br'), _vm._v(" "), _c('br'), _c('a', {
    attrs: {
      "name": "team"
    }
  }, [_c('h1', {
    staticClass: "darkbluefont font-weight-bolder"
  }, [_c('a', {
    attrs: {
      "href": "/team#team"
    }
  }, [_vm._v("Meet the American Credit core team")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("../assets/imgs/Corey_Rockafeler.png"),
      "alt": "American Credit Team Member Jennifer Tran"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h5 darkbluefont font-weight-bold"
  }, [_vm._v("Corey Rockafeler")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h5 darkbluefont font-weight-bold"
  }, [_vm._v("Business Development Executive")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n              • 25+ years developing financial and business strategies for C-level executives, entrepreneurs, top attorneys, and SMB owners \n              "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n              • Sr. VP Wealth manager for accounts such as Rothschild, Oppenheimer & Co., Prime Charter, and First Republic Group\n              "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n              •\tTop sales and achievement awards at leading companies such as Topdot Mortgage and Continental Home loans\n              "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n              •\tCore member of top fund-raising teams at Metropolitan Opera\n              "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n              •\tMayor Bloomberg’s top business development team (invited) at NYC Business Solutions. Developed and managed top accounts such as, 21 Club, Soho House, Mandarin Oriental, Sephora, Time Warner, to Whole Foods\n              "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n              •\tBusiness Development Director with fintech lender LiftForward\n              "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n              •\tGraduate works (on-going) at Harvard Business School and the London School of Economics\n              "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n              •\tBachelor of Arts (BA) International Politics, New York University\n              "), _c('br'), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/coreyrockafeler/",
      "target": "_blank"
    }
  }, [_vm._v("Profile in LinkedIn")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Team_Customer_Voice.png"),
      "alt": "American Credit Team Customer Voice"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("Laurie Townsend")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("Account Receivable Manager, Lone Star Uniform Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01646be2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/corey.vue
// module id = 1926
// module chunks = 5